import { z4 } from '@fiverr-private/forms';
import { translate } from '../translate';
import { SIGN_IN_USERNAME_REGEX } from './constants';
import { emailValidator } from './emailValidator';
import { newPasswordValidator } from './newPasswordValidator';

const isPotentialEmail = (value: string) => value.includes('@');

export const createSignInSchema = () =>
    z4.object({
        usernameOrEmail: z4
            .string()
            .refine(
                (value) => {
                    if (isPotentialEmail(value)) {
                        return true;
                    }

                    return SIGN_IN_USERNAME_REGEX.test(value);
                },
                {
                    error: translate('validation.identification_login.format_username_email', {}),
                }
            )
            .refine(
                (value) => {
                    if (!isPotentialEmail(value)) {
                        return true;
                    }

                    return emailValidator().safeParse(value).success;
                },
                {
                    error: translate('validation.identification_login.format_email'),
                }
            ),
        password: z4.string().min(1),
    });

export const createSignUpSchema = () =>
    createSignInSchema().extend({
        password: newPasswordValidator(),
    });

export type SignInFormSchema = z4.infer<ReturnType<typeof createSignInSchema>>;
export type SignUpFormSchema = z4.infer<ReturnType<typeof createSignUpSchema>>;
